import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { routes } from '@/router'
import {
  CardButton,
  CurrentPlanCard,
  NewFeatureChip,
  PageHeader,
} from '@/components'
import {
  AttachMoney,
  CreditCard,
  Group,
  ReceiptOutlined,
  ShieldOutlined,
  RequestQuote,
  Share,
  SwapVert,
  Widgets,
} from '@mui/icons-material'
import { Box, Stack } from '@mui/material'
import { useCompany } from '@/context/companies'
import { isNewFeature } from '@/helpers'
import { UserProfile } from '@/types'

export function MenuPage() {
  const { deal } = useCompany()

  const isInsuranceNew = isNewFeature('insurance')

  const isAdmin = useMemo(() => {
    const user = JSON.parse(
      localStorage.getItem('user-profile') || '{}',
    ) as UserProfile

    return (
      deal.deal_users.find((dealUser) => dealUser.profile === 'admin')
        ?.user_key === user.key
    )
  }, [deal])

  const menuItems = useMemo(
    () => [
      {
        name: 'Faturamento',
        route: routes.revenue,
        icon: <AttachMoney />,
      },
      {
        name: 'Notas Fiscais',
        route: routes.fiscalNotes.index,
        icon: <ReceiptOutlined />,
      },
      {
        name: 'Movimento mensal',
        route: routes.monthlyDocuments,
        icon: <SwapVert />,
      },
      {
        name: 'Guias de Impostos',
        route: routes.taxes,
        icon: <RequestQuote />,
      },
      {
        name: 'Sócios',
        route: routes.partners.index,
        icon: <Group />,
        hide: !isAdmin,
      },
      {
        name: 'Colaboradores',
        route: routes.collaborators,
        icon: <Group />,
        hide: !isAdmin,
      },
      {
        name: 'Serviços adicionais',
        route: routes.additionalServices,
        icon: <Widgets />,
      },
      {
        name: 'Seguros',
        route: routes.insurance,
        icon: <ShieldOutlined />,
        isNew: isInsuranceNew,
      },
      {
        name: 'Mensalidades',
        route: routes.billing,
        icon: <CreditCard />,
      },
      {
        name: 'Indique e Ganhe',
        route: routes.referAndEarn,
        icon: <Share />,
      },
    ],
    [isAdmin, isInsuranceNew],
  )

  return (
    <>
      <PageHeader>Menu</PageHeader>
      <Box mb={2}>
        <CurrentPlanCard />
      </Box>

      <Stack gap={1}>
        {menuItems.map((item) => (
          <CardButton
            key={item.name}
            component={Link}
            to={item.route.toString()}
            sx={{
              '& > svg': { color: 'secondary.main' },
              display: item.hide ? 'none' : 'flex',
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              {item.name}
              {item.isNew && <NewFeatureChip />}
            </Box>
            {item.icon}
          </CardButton>
        ))}
      </Stack>
    </>
  )
}
